function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.85,12.55c-2.04,2.23-.94,6.28,2.17,6.72h38.51c.7.04,1.49.46,1.72,1.14l.11,9.86c1.04.26,1.48.85,1.56,1.91.25,3.37-.2,7.06,0,10.47-.1.91-.76,1.45-1.55,1.8l-.11,10.21c-.21.67-.92,1.1-1.61,1.13l-38.98-.02c-3.39-.61-5.44-3.2-5.66-6.58V14.71c.36-3.46,2.8-6.22,6.36-6.48l36.41.1c1.4.61,1.33,2.53-.15,2.99H14.36c-.87.08-1.93.6-2.51,1.24ZM51.51,22.49H14.13c-.31,0-1.29-.26-1.64-.38-.57-.2-1.07-.6-1.63-.81v28.35c0,1.13,2.02,3.03,3.15,3.03h37.5v-8.2h-7.07c-3.66,0-6.37-4.06-6.25-7.44.12-3.16,2.88-6.83,6.25-6.83h7.07v-7.73ZM53.06,33.31h-8.74c-.16,0-1.01.35-1.21.45-2.66,1.39-2.74,5.46-.22,7.04.21.13,1.15.59,1.31.59h8.86v-8.08Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.4,16.51c-.88-.87-.34-2.71.97-2.82h37.33c2.16.44,1.92,3.31-.35,3.34H14.72c-.42-.01-1.03-.23-1.32-.52Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 45.05,
  cy: 37.31,
  r: 1.96
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Wallet-outlined.454fed7b.svg";
export { SvgComponent as ReactComponent };